<template>
    <div class="page-content">
        <component
            v-for="(section, x) in sections"
            :key="x"
            :is="resolveComponent(section.acf_fc_layout)"
            v-bind="section"
        />
    </div>
</template>

<script>
import HeroBanner from './HeroBanner.vue'
import ImageBanner from './ImageBanner.vue'

const BlankComponent = {
    props: {
        acf_fc_layout: String,
    },
    render(h) {
        return h('div', { domProps: { hidden: true }}, `No component found for ${this.acf_fc_layout}`)
    }
}

const SectionAwardsVideo = {
    components: {
        VideoAutoplay: () => import('../Ui/VideoAutoplay.vue'),
    },
    render(h) {
        return h('VideoAutoplay', {
            props: {
                media: 'Award_Wining_Culture',
                when: 'campus-microsite',
                custom: true,
            }
        })
    }
}

export default {
    props: {
        sections: {
            type: Array,
            required: true
        },
    },

    components: {
        BlankComponent,
        SectionAwardsVideo,
        HeroBanner,//: () => import(/* webpackChunkName: "landing-hero" */'./HeroBanner.vue'),
        ImageBanner,//: () => import(/* webpackChunkName: "landing-banner" */'./ImageBanner.vue'),
        SectionText: () => import(/* webpackChunkName: "landing-text-section" */'./SectionText.vue'),
        SectionTextIcons: () => import(/* webpackChunkName: "landing-text-icons-section" */'./SectionTextIcons.vue'),
        SectionDropdowns: () => import(/* webpackChunkName: "landing-dropdowns-section" */'./SectionDropdowns.vue'),
        SectionTestimonials: () => import(/* webpackChunkName: "landing-testimonials-section" */'./SectionTestimonials.vue'),
        SectionTextGallery: () => import(/* webpackChunkName: "landing-gallery-section" */'./SectionTextGallery.vue'),
        SectionColumns: () => import(/* webpackChunkName: "landing-columns-section" */'./SectionColumns.vue'),
        SectionStatistics: () => import(/* webpackChunkName: "landing-columns-section" */'./SectionStatistics.vue'),
    },

    methods: {
        resolveComponent(layout) {
            return resolver(layout)
        },
    },
}

function resolver( layout ) {
    switch (layout) {
        case 'image_banner':
            return 'ImageBanner'
        case 'hero_banner':
            return 'HeroBanner'
        case 'section_text':
            return 'SectionText'
        case 'section_awards_video':
            return 'SectionAwardsVideo'
        case 'section_text_and_icons':
            return 'SectionTextIcons'
        case 'section_dropdowns':
            return 'SectionDropdowns'
        case 'section_testimonials':
            return 'SectionTestimonials'
        case 'section_text_gallery':
            return 'SectionTextGallery'
        case 'section_columns':
            return 'SectionColumns'
        case 'section_statistics':
            return 'SectionStatistics'
        default:
            return 'BlankComponent'
    }
}
</script>